<template>
  <div class="inner1">
    <div class="inner_top1">
      <a-form
        layout="inline"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 17 }"
        labelAlign="right"
        :form="xhrParams"
      >
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="出勤日期" class="w100">
              <a-range-picker
                :disabled-date="disabledDate"
                @change="changeDate"
                format="YYYY-MM-DD"
                v-model="time"
              >
                <a-icon slot="suffixIcon" type="clock-circle" />
              </a-range-picker>
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item label="学生姓名/ID" class="w100">
              <a-input
                class="form-cell"
                placeholder="请输入"
                v-model="xhrParams.studentIdName"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col span="6">
            <a-form-item label="上课班级" class="w100">
              <a-select 
                allowClear
                show-search
                placeholder="请选择"
                v-model="xhrParams.classId"
                :not-found-content="fetching ? undefined : null"
                :filter-option="filterOption"
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option
                  :value="item.id"
                  v-for="item in classList"
                  :key="item.id"
                  >{{ item.className }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col span="6">
            <a-form-item label="年级" class="w100">
              <a-select
                allowClear
                show-search
                placeholder="请选择"
                v-model="xhrParams.gradeId"
                :not-found-content="fetching ? undefined : null"
                :filter-option="filterOption"
              >
                <a-select-option
                  :value="item.id"
                  v-for="item in gradeList"
                  :key="item.id"
                  >{{ item.tagName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col span="6">
            <a-form-item label="原始班级" class="w100">
              <a-select
                allowClear
                show-search
                placeholder="请选择"
                v-model="xhrParams.originalClassId"
                :not-found-content="fetching ? undefined : null"
                :filter-option="filterOption"
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option
                  :value="item.id"
                  v-for="item in originalClassList"
                  :key="item.id"
                  >{{ item.className }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col span="6">
            <a-form-item label="课程类型" class="w100">
              <a-select
                placeholder="请选择"
                v-model="xhrParams.courseClassifyId"
              >
                <a-select-option
                  :value="item.id"
                  v-for="item in classifyList"
                  :key="item.id"
                  >{{ item.tagName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col span="6">
            <a-form-item label="考勤状态" class="w100">
              <a-select
                placeholder="请选择"
                v-model="xhrParams.attendanceStatus"
              >
                <a-select-option
                  :value="item"
                  v-for="(item, key) in attendanceStatusList"
                  :key="item"
                  >{{ key }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-button type="primary" style="margin-left: 20px" @click="submit">查询</a-button>
            <a-button style="margin-left: 20px" @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="inner_con1">
      <a
        style="display: inlne-block"
        :class="downLoading ? 'disabled' : ''"
        @click="!downLoading ? exportList() : ''"
      >
        {{ downLoading ? '导出中...' : 'Excel导出' }}
      </a>
      <a-table
        :loading="tableLoading"
        :columns="columns"
        style="margin-top: 24px"
        :pagination="pagination"
        :data-source="tableData"
        @change="tableChange"
        :rowKey="getRowKey"
      >
        <span slot="attendDate" slot-scope="text, record">{{
          text + " " + record.haveClassTime
        }}</span>
        <span slot="checkinTime" slot-scope="text, record">{{
          record.checkinTime | date('MM-DD HH:mm:ss')
        }}</span>
      </a-table>
    </div>
  </div>
</template>

<script>
import { downloadExcelFile } from '../../utils'
import moment from 'moment'
import Vue from 'vue'
import {
  studentAttendanceDetailsForm,
  studentAttendanceList,
} from '../../api/report'
import dayjs from 'dayjs'
const columns = [
  {
    title: '学生ID',
    dataIndex: 'studentId',
  },
  {
    title: '学生姓名',
    dataIndex: 'studentName',
  },
  {
    title: '性别',
    dataIndex: 'genderName',
  },
  {
    title: '所属学校',
    dataIndex: 'studentSchoolName',
  },
  {
    title: '年级',
    dataIndex: 'gradeName',
  },
  {
    title: '原始班级',
    dataIndex: 'originalClassName',
  },
  {
    title: '课程分类',
    dataIndex: 'courseClassifyName',
  },
  {
    title: '课程名称',
    dataIndex: 'courseName',
  },
  {
    title: '班级',
    dataIndex: 'className',
  },
  {
    title: '课节日期',
    dataIndex: 'attendDate',
    scopedSlots: { customRender: 'attendDate' },
  },
  {
    title: '考勤时间',
    dataIndex: 'checkinTime',
    scopedSlots: { customRender: 'checkinTime' },
  },
  {
    title: '考勤状态',
    dataIndex: 'attendanceStatusName',
  },
]
export default {
  data() {
    return {
      xhrParams: {},
      columns,
      pagination: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        currentPage: 1,
        showQuickJumper: true,
        showLessItems: true,
      }, //分页数据对象
      tableLoading: false,
      fetching: false,
      downLoading: false,
      tableData: [
        {
          studentId: 65331,
          studentName: '谭颖',
          gender: 2,
          genderName: '女',
          studentSchoolId: 126,
          studentSchoolName: '学校体验号学校名称',
          gradeId: 4,
          gradeName: '一年级',
          originalClassId: 328,
          originalClassName: '一（0）班',
          courseClassifyId: 3,
          courseClassifyName: '托管班',
          courseId: 463,
          courseName: '测试生成课节',
          classId: 603,
          className: '滨江月亮湾',
          attendDate: '2022-08-30 19:50:01',
          classSchoolId: 126,
          classSchoolName: '学校体验号学校名称',
          attendanceStatus: 0,
          attendanceStatusName: '待签到',
          haveClassDate: '2022-08-30 00:00:00',
          haveClassTime: '15:00-15:45',
        },
      ],
      attendanceStatusList: [],
      classifyList: [],
      originalClassList: [],
      gradeList: [],
      classList: [],
    }
  },
  created() {
    this.xhrParams = {}
    this.time = [moment(dayjs().subtract(1, "month").format('YYYY-MM-DD')),moment(dayjs())]
    this.xhrParams.attendanceStart = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
    this.xhrParams.attendanceEnd = dayjs().format('YYYY-MM-DD')
    console.log(' this.xhrParams', this.xhrParams)
    this.studentAttendanceDetailsForm()
    this.studentAttendanceList({ ...this.pagination, ...this.xhrParams })
  },
  methods: {
    exportList() {
      let _this = this
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          _this.xhrParams.schoolId = Vue.ls.get('schoolId')
      let a = { ..._this.xhrParams }
      if (a.time) {
        delete a.time
      }
      // console.log('this.xhrParams', this.xhrParams)
      _this.downLoading = true
      downloadExcelFile(
        '/api/pcWeb/report/exportStudentAttendanceDetails',
        '学生出勤.xlsx',
        a
      ).then(() => {
        _this.downLoading = false
      })
        },
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    tableChange(pagination, filters, sorter) {
      this.pagination = pagination
      this.pagination.currentPage = pagination.current
      this.studentAttendanceList({ ...this.xhrParams, ...pagination })
    },
    studentAttendanceList(params) {
      this.pagination.currentPage = params.currentPage
      this.pagination.current = params.currentPage
      this.tableLoading = true
      studentAttendanceList(params).then((res) => {
        this.tableData = res.data.records
        this.tableLoading = false
        this.pagination.pages = res.data.pages
        this.pagination.pageSize = res.data.size
        const total = res.data.total
        this.pagination.total = res.data.total
        if (total > 10000 && !this.pagination.pageSizeOptions.includes('120')) {
          this.pagination.pageSizeOptions = [
            ...this.pagination.pageSizeOptions,
            '120',
            '150',
          ]
        }
        if (
          total > 100000 &&
          !this.pagination.pageSizeOptions.includes('200')
        ) {
          this.pagination.pageSizeOptions.push('200')
        }
      })
    },
    reset() {
      this.xhrParams = {}
      this.time = [moment(dayjs().subtract(1, "month").format('YYYY-MM-DD')),moment(dayjs())]
      this.xhrParams.attendanceStart = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
      this.xhrParams.attendanceEnd = dayjs().format('YYYY-MM-DD')
    },
    submit() {
      this.studentAttendanceList({
        ...this.xhrParams,
        currentPage: 1,
        pageSize: this.pagination.pageSize
      })
      this.pagination.current = 1
    },
    // 控制选择日期范围
    disabledDate(current) {
      return current && current > moment().endOf('day')
    },
    getRowKey(record, index) {
      return index;
    },
    // 选择日期
    changeDate(event) {
      if (!event.length) {
        this.xhrParams.attendanceStart = ''
        this.xhrParams.attendanceEnd = ''
        return
      }
      const startDate = moment(event[0])
      let endDate = moment(event[1])
      if (endDate.diff(startDate, 'days') > 365) {
        endDate = moment(startDate).add(1, 'year')
        this.time = [startDate, endDate]
        this.$message.warn('请选择起始日期1年内的日期')
      }
      console.log('changeDate', startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'))
      this.xhrParams.attendanceStart = startDate.format('YYYY-MM-DD')
      this.xhrParams.attendanceEnd = endDate.format('YYYY-MM-DD')
      this.$forceUpdate()
    },
    //导出学生考勤信息列表查询表单
    studentAttendanceDetailsForm() {
      studentAttendanceDetailsForm().then((res) => {
        this.attendanceStatusList = res.data.attendanceStatusList
        this.classifyList = res.data.classifyList
        this.originalClassList = res.data.originalClassList
        this.gradeList = res.data.gradeList
        this.classList = res.data.classList
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';
.w100 {
  width: 100%;
}
.inner1 {
  width: calc(100% - 40px);
  margin: 20px auto;
  .inner_top1 {
    background: #fff;
    padding: 20px;
    margin-bottom: 24px;
  }
  .inner_con1 {
    background: #fff;
    padding: 20px;
  }
}
.ulrow {
  display: flex;
  flex-wrap: wrap;
}
.ulrow_list {
  width: calc(100% / 4);
  margin-bottom: 15px;
}
::v-deep .ant-col {
  margin-bottom: 5px;
}
</style>
